import React from 'react';
import { $SliderElement } from './styles';
export const SliderElement = ({ children, visibleSlides, slideMargin, onClickElement, id, }) => {
    return (React.createElement($SliderElement, { visibleSlides: visibleSlides, slideMargin: slideMargin, onClick: () => { if (onClickElement)
            onClickElement(id); } }, children));
};
